import { AppState } from '@/store';

export const selectAccessibilityTop = (state: AppState) => state.accessibility.accessibilityTop;
